export default function MobileStickyBar() {
  return <div className="fixed bottom-0 inset-x-0 z-50 bg-white border-t border-gray-200 p-3 pb-[max(12px,env(safe-area-inset-bottom))] md:hidden shadow-lg">
    <div className="flex gap-3">
      <a href="tel:+351965715768" className="flex-1 bg-segredo-yellow text-segredo-black py-4 rounded-lg font-bold text-center">Ligar 24h</a>
      <a href="https://wa.me/351965715768" className="flex-1 bg-[#166534] text-white py-4 rounded-lg font-bold text-center">WhatsApp</a>
    </div>
    <p className="text-center text-xs text-gray-600 mt-2">Confirme a disponibilidade por telefone</p>
  </div>;
}
